<template>
  <div @click="$emit('selected')">
    <v-card
      height="77px"
      width="50px"
      rounded
      color="info"
      hover
      variant="flat"
    >
      <v-container fluid class="pa-0">
        <div v-if="side !== 'legend'">
          <v-row no-gutters>
            <v-spacer />
            <v-card
              height="7px"
              width="20px"
              rounded
              :color="side === 'u.e.' ? 'primary' : undefined"
              class="mt-1"
            />
            <v-spacer />
          </v-row>
          <v-row no-gutters>
            <v-spacer />
            <v-card
              height="20px"
              width="7px"
              rounded
              :color="side === 'le.e.' ? 'primary' : undefined"
              class="mt-1"
            />
            <v-spacer />
            <v-card
              height="20px"
              width="20px"
              rounded
              :color="
                side === 'obv.' || side === 'mirror text'
                  ? getObverseColor()
                  : undefined
              "
              class="mt-1"
            />
            <v-spacer />
            <v-card
              height="20px"
              width="7px"
              rounded
              :color="side === 'r.e.' ? 'primary' : undefined"
              class="mt-1"
            />
            <v-spacer />
          </v-row>
          <v-row no-gutters>
            <v-spacer />
            <v-card
              height="7px"
              width="20px"
              rounded
              :color="side === 'lo.e.' ? 'primary' : undefined"
              class="mt-1"
            />
            <v-spacer />
          </v-row>
          <v-row no-gutters>
            <v-spacer />
            <v-card
              height="20px"
              width="20px"
              rounded
              :color="side === 'rev.' ? 'primary' : undefined"
              class="mt-1"
            />
            <v-card
              height="20px"
              width="20px"
              :color="side === 'suppl. tablet' ? 'primary' : 'transparent'"
              class="mt-1 ml-n5 rounded-circle"
              :flat="side !== 'suppl. tablet'"
            />
            <v-card
              height="7px"
              width="20px"
              :color="side === 'obv. ii' ? 'primary' : 'transparent'"
              class="mt-1 ml-n5 rounded-pill"
              :flat="side !== 'obv. ii'"
            />
            <v-spacer />
          </v-row>
        </div>
        <div v-else>
          <v-row no-gutters>
            <v-spacer />
            <v-card
              height="66px"
              width="10px"
              rounded
              color="white"
              class="mt-1"
            />
            <v-spacer />
            <v-card
              height="66px"
              width="10px"
              rounded
              color="white"
              class="mt-1"
            />
            <v-spacer />
            <v-card
              height="66px"
              width="10px"
              rounded
              color="white"
              class="mt-1"
            />
            <v-spacer />
          </v-row>
        </div>
      </v-container>
    </v-card>
    <v-row no-gutters class="mt-1 mx-n3 justify-center">
      {{ side }}

      <v-menu v-if="side === 'obv. ii'" open-on-hover location="bottom">
        <template #activator="{ props }">
          <v-icon v-bind="props" class="ml-1 mr-n2" size="small">
            mdi-information-outline
          </v-icon>
        </template>
        <v-card class="pa-3">
          <span>
            For use only when writer continues from u.e. onto obv. near end of
            text.
          </span>
        </v-card>
      </v-menu>
    </v-row>
  </div>
</template>

<script lang="ts">
import { EpigraphicUnitSide } from '@oare/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    side: {
      type: String as PropType<EpigraphicUnitSide>,
      required: true,
    },
  },
  emits: ['selected'],
  setup(props) {
    const getObverseColor = () => {
      if (props.side === 'obv.') {
        return 'primary';
      } else if (props.side === 'mirror text') {
        return 'grey-darken-1';
      }
    };
    return {
      getObverseColor,
    };
  },
});
</script>
